/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 public/logo.gltf 
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const { nodes, materials } = useGLTF('/logo.gltf')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Curve.geometry} material={materials.MainMaterial} rotation={[Math.PI / 2, 0, 0]} scale={25.756} />
    </group>
  )
}

useGLTF.preload('/logo.gltf')
